import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

export default {
  uiSchema: {
    militaryServiceCurrentlyServing: yesNoUI({
      title: 'Are you currently serving in the military?',
      hint:
        'This includes active-duty service and service in the National Guard and Reserves.',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      militaryServiceCurrentlyServing: yesNoSchema,
    },
  },
};
